import { Extension } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Image from '@tiptap/extension-image';
import Underline from '@tiptap/extension-underline';
import { TextStyle, Color } from '@tiptap/extension-text-style';
import Placeholder from '@tiptap/extension-placeholder';
import { KonspektCodeStatic, KonspektPyRun } from './konspektPythonBlocksExtension.jsx';

/** id у заголовков — для оглавления (#якорь). */
const HeadingId = Extension.create({
  name: 'headingId',
  addGlobalAttributes() {
    return [
      {
        types: ['heading'],
        attributes: {
          id: {
            default: null,
            parseHTML: (el) => el.getAttribute('id'),
            renderHTML: (attrs) => (attrs.id ? { id: attrs.id } : {}),
          },
        },
      },
    ];
  },
});

export function getKonspektExtensions({ placeholder = 'Текст конспекта…', editable = true } = {}) {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
      bulletList: { keepMarks: true, keepAttributes: false },
      orderedList: { keepMarks: true, keepAttributes: false },
      codeBlock: false,
    }),
    Underline,
    TextStyle,
    Color,
    Link.configure({
      openOnClick: !editable,
      autolink: true,
      defaultProtocol: 'https',
      HTMLAttributes: { class: 'konspekt-link' },
    }),
    Image.configure({
      HTMLAttributes: { class: 'konspekt-image' },
    }),
    Placeholder.configure({ placeholder }),
    HeadingId,
    KonspektPyRun,
    KonspektCodeStatic,
  ];
}
